import React from 'react'
import ReactDOM from "react-dom";


function InsightsModal({ isOpen, onClose, group, children, heading }) {


    if (!isOpen) return null;
    return ReactDOM.createPortal(
        <div className="fixed top-0 left-0 w-full h-screen bg-[#000000b9] flex justify-center items-start z-30 overflow-y-auto">
            <div className="bg-white dark:bg-[#121519] h-auto py-3 px-5 w-full min-h-screen max-h-screen  overflow-y-auto">

                <div className='w-[100%] flex justify-between'>
                    <span className='text-[#121519] font-semibold text-[18px] dark:text-[#fff]'>
                        {heading}
                    </span>

                    <button className="text-[#858484]" onClick={onClose}>
                        ✖
                    </button>
                </div>

                {children}
            </div>
        </div>, document.getElementById("portal-root")
    )
}

export default InsightsModal